import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconSecurity.tsx
const OutlinedFilledSecurity = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.94-54Q329.1-91.81 232.05-226.41 135-361.01 135-521.67v-255.79L480-906l346 128.57V-522q0 160.79-97.62 295.49Q630.77-91.81 479.94-54Zm.06-96q101-39 168.46-128.05 67.46-89.04 79.54-202.07H480V-805l-251 94.48V-522q0 11 .5 20.5t2.42 21.5H480v330Z" })
});
const OutlinedSecurity = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.94-54Q329.1-91.81 232.05-226.41 135-361.01 135-521.67v-255.79L480-906l346 128.57V-522q0 160.79-97.62 295.49Q630.77-91.81 479.94-54Zm.06-96q101-39 168.46-128.05 67.46-89.04 79.54-202.07H480V-805l-251 94.48V-522q0 11 .5 20.5t2.42 21.5H480v330Z" })
});
const RoundedFilledSecurity = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-150q101-39 168.5-128T728-480H480v-325l-251 94v189q0 11 .5 20.5T232-480h248v330Zm0 90q-8 0-15.5-1.5T450-66q-144-47-229.5-177.5T135-523v-189q0-30 16.5-55t44.5-35l251-94q16-6 33-6t33 6l251 94q28 10 45 35t17 55v189q0 149-86 279.5T510-66q-7 3-14.5 4.5T480-60Z" })
});
const RoundedSecurity = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-150q101-39 168.5-128T728-480H480v-325l-251 94v189q0 11 .5 20.5T232-480h248v330Zm0 90q-8 0-15.5-1.5T450-66q-144-47-229.5-177.5T135-523v-189q0-30 16.5-55t44.5-35l251-94q16-6 33-6t33 6l251 94q28 10 45 35t17 55v189q0 149-86 279.5T510-66q-7 3-14.5 4.5T480-60Z" })
});
const SharpFilledSecurity = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.94-54Q329.1-91.81 232.05-226.41 135-361.01 135-521.67v-255.79L480-906l346 128.57V-522q0 160.79-97.62 295.49Q630.77-91.81 479.94-54Zm.06-96q101-39 168.46-128.05 67.46-89.04 79.54-202.07H480V-805l-251 94.48V-522q0 11 .5 20.5t2.42 21.5H480v330Z" })
});
const SharpSecurity = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.94-54Q329.1-91.81 232.05-226.41 135-361.01 135-521.67v-255.79L480-906l346 128.57V-522q0 160.79-97.62 295.49Q630.77-91.81 479.94-54Zm.06-96q101-39 168.46-128.05 67.46-89.04 79.54-202.07H480V-805l-251 94.48V-522q0 11 .5 20.5t2.42 21.5H480v330Z" })
});
const componentMap = {
	outlined: OutlinedSecurity,
	"outlined-fill": OutlinedFilledSecurity,
	rounded: RoundedSecurity,
	"rounded-fill": RoundedFilledSecurity,
	sharp: SharpSecurity,
	"sharp-fill": SharpFilledSecurity
};
const IconSecurity = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconSecurity };